import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import './multiRangeSlider.scss';

const MultiRangeSlider = ({
  min,
  max,
  step,
  parentClassName,
  onChange,
  sliderSize,
}) => {
  const [minVal, setMinVal] = useState(min);
  const [maxVal, setMaxVal] = useState(max);
  const minValRef = useRef(min);
  const maxValRef = useRef(max);
  const range = useRef(null);

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxVal, getPercent]);

  return (
    <div className={parentClassName} dir="ltr">
      <input
        type="range"
        className="thumbRange thumbRange--left"
        min={min}
        max={max}
        value={minVal}
        step={step}
        onChange={(event) => {
          const value = Math.min(Number(event.target.value), maxVal - 1);
          setMinVal(value);
          minValRef.current = value;
          onChange({ min: minVal, max: maxVal });
        }}
        style={{
          zIndex: minVal > max - 100 && '5',
          width: `${sliderSize - 3}%`,
        }}
      />
      <input
        type="range"
        className="thumbRange thumbRange--right"
        style={{
          width: `${sliderSize - 3}%`,
        }}
        min={min}
        max={max}
        value={maxVal}
        step={step}
        onChange={(event) => {
          const value = Math.max(Number(event.target.value), minVal + 1);
          setMaxVal(value);
          maxValRef.current = value;
          onChange({ min: minVal, max: maxVal });
        }}
      />

      <div
        className="position-relative slider"
        style={{
          width: `${sliderSize}%`,
        }}
      >
        <div className="position-absolute w-100 slider__track" />
        <div ref={range} className="position-absolute slider__range" />
        <div
          className="position-absolute slider__left-value"
          style={{
            color: '#607080',
          }}
        >
          {minVal}
        </div>
        <div className="position-absolute slider__right-value text-dark">
          {maxVal}
        </div>
      </div>
    </div>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  parentClassName: PropTypes.string,
  sliderSize: PropTypes.number,
  onChange: PropTypes.func,
};

MultiRangeSlider.defaultProps = {
  min: 0,
  max: 1000,
  step: 1,
  sliderSize: 80,
  parentClassName: 'd-flex justify-content-center my-2',
  onChange: () => {
    console.error('component has not onChange func');
  },
};
export default MultiRangeSlider;
